<script lang="ts">
  /* A section boundary inside a scrolling panel.
   *
   * A rule that runs to the end of the line, not a bare label: the eyebrow is
   * ten pixels of pixel-font, and in a panel long enough to scroll — a schedule
   * with five waypoints and a passage block above it — ten pixels of small caps
   * is not a boundary anybody sees. The rule is what makes "the tide ones" a
   * place rather than a search.
   *
   * Replaces `.lbl` in RouteContent and Sheet, `.grp` in Layers, and
   * SchedulePanel's own `.lbl` — which were the same thing at 10 px in three
   * different faces.
   */
  import type { Snippet } from 'svelte';

  let {
    title,
    /** The right-hand end: a count, a chip, a clear-all. Kept off the rule so
     *  the boundary still reads as one line. */
    aside
  }: { title: string; aside?: Snippet } = $props();
</script>

<div class="shead">
  <span class="t">{title}</span>
  <span class="rule"></span>
  {#if aside}<span class="aside">{@render aside()}</span>{/if}
</div>

<style>
  .shead {
    display: flex;
    align-items: center;
    gap: var(--sp-4);
    margin: var(--sp-6) 0 var(--sp-3);
  }
  /* The first section in a panel body sits directly under the header, which has
     its own padding — a second margin there reads as a gap somebody forgot. */
  .shead:first-child {
    margin-top: 0;
  }
  .t {
    flex: none;
    font: var(--fs-label) / 1 var(--px);
    letter-spacing: var(--tr-label);
    color: var(--sub);
    text-transform: uppercase;
  }
  .rule {
    flex: 1;
    height: 1px;
    background: var(--line);
  }
  .aside {
    flex: none;
  }
</style>
